function Order({order}){
  return(
    <span className="me-2" style={{color:'var(--color-secondary)'}}>
      {order}
    </span>
  );
}

export default Order
